import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";

export default function AiTodoPreview({ count, onOpen }) {
  if (!count) return null;

  return (
    <button
      type="button"
      className="ai-todo-preview"
      onClick={onOpen}
      aria-label={`Open to-do list with ${count} pending items`}
    >
      <span className="ai-todo-preview__icon" aria-hidden="true">
        <FontAwesomeIcon icon={faClock} />
      </span>
      <span className="ai-todo-preview__copy">
        <strong>{`To-do List has ${count} pending items`}</strong>
        <small>
          Payroll approval &middot; Pending transfers &middot; Export Request
          Approval
        </small>
      </span>
      <span className="ai-todo-preview__action">View all</span>
    </button>
  );
}
